import React, { useContext, useEffect, useMemo, useState } from "react";
import { saveAs } from "file-saver";
import { LoadingState } from "../../../../hooks/loading";
import { ElementLoading } from "../../../shared/other/Loading";
import { Bar, ChartData } from "react-chartjs-2";
import { Skeleton } from "@material-ui/lab";
import { Grid, Paper, Typography, useTheme } from "@material-ui/core";
import { useDimensions } from "../../../../hooks/dimensions";
import { useChartOptions } from "../../../../hooks/chartOptions";
import { useDownloadStatistics } from "../../../../hooks/downloadStatistics";
import { usePdfHelper } from "../../../../hooks/pdfhelper";
import { ChartFunctions } from "../ChartFunctions";
import { useStatistics } from "../../../../hooks/statistics";
import { StatisticsStateContext } from "../../../../state/statistics";
import { useChartStyles } from "../StatisticsPage";
import { ChartFilters } from "../ChartFilters";
import { BreadCrumbHeadline } from "../../../shared/other/Breadcrumb";
import ArrowRight from "@material-ui/icons/ArrowRight";

export const ImportedByYearChart: React.FC<{
  amount: number;
}> = (props) => {
  const [context, dispatch] = useContext(StatisticsStateContext);
  const { yearState, initialData } = useStatistics({taxRequest: {yearRequest: context.filterData.year.request}});
  const { width } = useDimensions("tax-inspection-by-year-paper-width");
  const classes = useChartStyles({ width: width as number });
  const theme = useTheme();
  const { downloadYearState, downloadYearVins } = useDownloadStatistics();

  useEffect(() => {
    if (context.graphData.toldsynByYearResults != null && context.graphData.toldsynByYearResults != undefined) {
      createChart();
    }
  }, [context.graphData.toldsynByYearResults, props.amount]);

  const chartRef = useMemo(() => {
    return React.createRef<Bar>();
  }, []);

  const [options] = useChartOptions<Bar>(chartRef, false, false);
  const [chartData, setChartData] = useState<ChartData<Chart.ChartData>>({});

  const { getAsPdf } = usePdfHelper();

  const downloadPdf = async () => {
    var title = "Amount of tax inspections distributed over inspection year";
    var data = await getAsPdf(chartRef.current?.chartInstance.toBase64Image() as string, context.filterData.year.request, title);
    saveAs("data:application/pdf;base64," + data, title + ".pdf");
  }

  const createChart = () => {
    var data = {
      labels: context.graphData.toldsynByYearResults?.slice(0, props.amount).map(p => p.year as string),
      datasets: [{
        label: '# of imported tax inspections',
        data: context.graphData.toldsynByYearResults?.slice(0, props.amount).map(p => p.toldsynResultsImported),
        backgroundColor: theme.primaryChart.color,
        borderColor: theme.primaryChart.background,
        borderWidth: 1,
      },
      {
        label: '# of exported tax inspections',
        data: context.graphData.toldsynByYearResults?.slice(0, props.amount).map(p => p.toldsynResultsExported),
        backgroundColor: theme.secondaryChart.color,
        borderColor: theme.secondaryChart.background,
        borderWidth: 1
      }]
    };
    setChartData(data);
  }
  return (<>
    <Paper className={classes.header}>
        <Grid container spacing={1} alignItems="center">
          <BreadCrumbHeadline item sm={6} xs={12}>
          <Typography variant="h5">Tax inspections</Typography>
          <ArrowRight fontSize="default" />
            <Typography variant="h5">Per inspection year</Typography>
          </BreadCrumbHeadline>
          <Grid item sm={6} xs={12}>
          <ChartFunctions toggled={context.filterData.year.showFilters} onToggleFilters={() => dispatch({type: "setShowYearFilter"})} downloadPdf={downloadPdf} downloadVins={() => downloadYearVins(context.filterData.year.request)}></ChartFunctions>
          </Grid>
        </Grid>
      </Paper>

      <Paper hidden={!context.filterData.year.showFilters} className={classes.filter}>
      <ChartFilters
            initialFilterData={initialData.initialFilterData}
            request={{info: context.filterData.year, setRequest: (request) => dispatch({type: "setYearRequest", request: request})}}
            initialLoading={initialData.toldsynByYearResults == undefined} />
      </Paper>
    
    <Paper className={classes.chart}><div id="tax-inspection-by-year-paper-width" style={{ position: "relative" }}>
      {initialData.toldsynByYearResults == undefined ? <Skeleton variant="rect" className={classes.skeleton}></Skeleton>
        :
        <>
          {yearState == LoadingState.Loading || downloadYearState == LoadingState.Loading ?
            <ElementLoading position="absolute"></ElementLoading> : null}
          <Bar ref={chartRef} data={chartData} options={options}></Bar>
        </>} </div></Paper></>)
}
